export default {
  sorry: { english: "Sorry", spanish: "Lo siento" },
  goBack: { english: "Go Back", spanish: "Volver" },
};
